import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { BaseComponent } from 'src/app/common/base/base.component';
import { WFStepConfig } from 'src/app/components/workflow/workflow';
import { WorkFlowService } from 'src/app/components/workflow/workflow.service';
import { Value } from '../../../../components/checklists/checklist-exec/checklist-tasks/checklist-task/checklist-task.component';

@Component({
  selector: 'cl-editor-next-step',
  templateUrl: './cl-editor-next-step.component.html',
  styleUrls: ['./cl-editor-next-step.component.scss'],
})
export class ClEditorNextStepComponent extends BaseComponent implements OnInit {
  @Input() disabled!: boolean;
  @Input() wfTableConfigID!: number;
  @Input() wfStepConfigID?: number;

  @Output() selected = new EventEmitter<any>();
  stepCtrl = new FormControl();

  step?: WFStepConfig;
  steps?: WFStepConfig[];
  stepsFiltered?: WFStepConfig[];

  constructor(
    protected override injector: Injector,
    private service: WorkFlowService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.service
      .getWFStepConfigs(this.wfTableConfigID)
      .toPromise()
      .then((steps) => {
        this.steps = steps?.sort((a, b) => this.utils.sort((a.wfSectionConfig.order ?? 0) * 100 + (a.order ?? 0), (b.wfSectionConfig.order ?? 0) * 100 + (b.order ?? 0)));
        this.stepsFiltered = steps;
        this.step = steps?.find((s) => s.id === this.wfStepConfigID);
      });
  }

  changedStep(e: any) {
    if (e.target.Value) {
      const value = e.target?.value?.toString().tolowerCase();
      this.stepsFiltered = this.steps?.filter((step) =>
        step.name?.toLowerCase()?.includes(value)
      );
    }
    else {
      this.clean();
    }
  }

  selectedStep(e: MatAutocompleteSelectedEvent) {
    this.step = e.option.value;
    this.selected.emit(e.option.value.id);
  }

  displayStep = (step: WFStepConfig): string => {
    if (step)
      return step.wfSectionConfig?.name + ' - ' + step.name;
    return '';
  };

  clean() {
    this.step = undefined;
    this.selected.emit(this.step);
  }
}
